import React, { useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { IconButton, Avatar } from "@mui/material";
import Box from '@mui/material/Box';
import LogoutIcon from '@mui/icons-material/Logout';
import { useMsal } from "@azure/msal-react";

const ProfileContent = () => {
  const { instance, accounts } = useMsal();
  const [userName, SetUserName] = useState('')
  useEffect(() => {
    if (accounts && accounts[0]) {
      SetUserName(accounts[0].name?.toUpperCase().charAt(0));
    }
  }, []);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    setAnchorEl(null);
    
    try {
      const account = instance.getActiveAccount() || accounts[0];
      
      // Clear session storage and local app state
      sessionStorage.clear();
      
      if (account) {
        // OPTION A: App-only logout (recommended)
        // Signs out of THIS app only, keeps user signed in to Microsoft elsewhere
        instance.setActiveAccount(null);
        window.location.href = "/";
        
        // OPTION B: Full Azure AD logout (uncomment if needed)
        // Signs user out of ALL Microsoft services globally
        /*
        await instance.logoutRedirect({
          account: account,
          postLogoutRedirectUri: "/",
        });
        */
      } else {
        window.location.href = "/";
      }
    } catch (error) {
      console.error("Logout error:", error);
      sessionStorage.clear();
      instance.setActiveAccount(null);
      window.location.href = "/";
    }
  }

  return (
    <>
      <React.Fragment>
        <Box
          sx={{ display: "flex", alignItems: "center", textAlign: "center" }}
        >
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar style={{color:"#1976d2"}} sx={{ width: 32, height: 32 }}>{userName}</Avatar>
          </IconButton>
        </Box>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem onClick={handleLogout}>
            <LogoutIcon />  Log out
          </MenuItem>
        </Menu>
      </React.Fragment>
    </>
  );
};

export default ProfileContent;
